import folder from './folder'
import folders from './folders'
import folderForm from './folderForm'
import folderModal from './folderModal'
import folderDestroy from './folderDestroy'

export default {
  folder,
  folders,
  folderForm,
  folderModal,
  folderDestroy
}



// WEBPACK FOOTER //
// ./src/store/modules/folders/index.js